import React from 'react';

const https = require('https');
const querystring = require('querystring');

class ContactForm extends React.Component {
	
	constructor() {
			super();
			this.handleSubmit = this.handleSubmit.bind(this);
			this.state = {
				submitted: false,
				form_error: false
			};
		};

	

	/* eslint-disable */
	handleSubmit(event) {
		this.setState({'submitted': 'pending'});

		event.preventDefault();
		const form = event.target;
		const data = new FormData(form);

		// Transforming form data before POST submission
		let data_dict = {};
		for(var key of data.entries()){
			data_dict[key[0]] = key[1];
		}

		// Prepare the data for posting
		var postData = querystring.stringify(data_dict);

		// set the post options, changing out the HUB ID and FORM GUID constiables.
		const options = {
			hostname: 'forms.hubspot.com',
			path: '/uploads/form/v2/4898671/26f9b428-5d64-4104-93db-2514570bbd26',
			method: 'POST',
			headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Content-Length': postData.length
				}
		}

		// set up the request
		const request = https.request(options, (response) => {
			console.log("Status: " + response.statusCode);
			if(response.statusCode == 204) { 
				this.setState({'submitted': true }); 
			} else {
				this.setState({'submitted': false, 'form_error': true});
			};
			console.log("Headers: " + JSON.stringify(response.headers));
			response.setEncoding('utf8');
			response.on('data', function(chunk){
					console.log('Body: ' + chunk)
				});
			});

		request.on('error', function(e){
			console.log("Problem with request " + e.message)
		});

		// post the data
		request.write(postData);
		request.end();
	};

	render() {
		return(
			<section className="section is-medium is-relative section-feature-grey" id="contact-form">
				
				{ this.state.submitted === false ?
					<div className="container">
						<div className="section-title-wrapper has-text-centered">
							<div className="bg-number">?</div>
								<h2 className="section-title-landing">Ready to get started</h2>
								<h4>Get in touch</h4>
								{
									this.state.form_error == true ?
										<h6 className="form-error">
										<b>Error Occurred while submitting. Please Try again !</b></h6>
									:
										null
									}
							</div>
						<div className="content-wrapper giant-pb">
							<form onSubmit={this.handleSubmit}>
								<div className="columns">
									<div className="column is-8 is-offset-2">
										<div className="columns is-vcentered">
											<div className="column is-3">
												<div className="control-material is-accent">
													<input name="name" className="material-input" type="text" required />
													<span className="material-highlight" />
													<span className="bar" />
													<label>Name *</label>
												</div>
											</div>
											<div className="column is-3">
												<div className="control-material is-accent">
													<input name="email" className="material-input" type="email" required />
													<span className="material-highlight" />
													<span className="bar" />
													<label>Email *</label>
												</div>
											</div>
											<div className="column is-3">
												<div className="control-material is-accent">
													<input name="company" className="material-input" type="text" required />
													<span className="material-highlight" />
													<span className="bar" />
													<label>Company *</label>
												</div>
											</div>
											<div className="column is-3 form-submitbutton">
												<
													button type="submit" 
													className="button button-cta btn-align secondary-btn btn-outlined is-bold rounded raised no-lh"
												>
													Submit
												</button>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
		
				:	
					
					[
						(this.state.submitted === true ?
							<div className="container" key="submitted">
								<div className="section-title-wrapper has-text-centered">
									<h1 className="section-title-landing">Message Successfully Sent</h1>
								</div>
								<div className="content-wrapper giant-pb has-text-centered">
									<img src="/files/images/illustrations/UI/message-sent.png" alt="message-sent" width="550" height="180" />
								</div>
							</div>
							:
								<div className="container" key="pending">
									<div className="section-title-wrapper has-text-centered">
										<div className="loader" key="pending">Loading...</div>
									</div>
								</div>
						)
					]
				}
		</section>
		)
	}
};

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/contact.jsx